export default {
  title: "Crea tu wallet",
  description: "Necesitas crear una wallet para continuar",
  button: "Crear wallet",
  advantages: {
    title: "Ventajas",
    biometric: {
      title: "Biometría",
      description:
        "firma tus transacciones con tu propia biometría (FaceID o huella dactilar). No tienes que hacer nada más, así de fácil.",
    },
    multiDevice: {
      title: "Multidispositivo",
      description:
        "puedes usar tu misma cuenta de HumanWallet desde cualquier equipo, accediendo con tu misma clave privada.",
    },
  },
  disadvantages: {
    title: "Inconvenientes",
    selfCustody: {
      title: "Autocustodia",
      description:
        "tus claves privadas están tan seguras como lo esté el proveedor en el que las guardas (Apple, Google o un tercero).",
    },
  },
  learnMore: "Saber más",
  learnMoreModal: {
    title: "HumanWallet",
    websiteLink: "humanwallet.io",
  },
  logoAlt: "HumanWallet Logo",
  checkbox:
    "Confirmo que he entendido que Antipartido no es el responsable de guardar la clave privada de mi billetera, siendo yo el único responsable para ello",
  backButton: "Volver a empezar",
}
